// Components
import { Container } from '../../components/core/container/Container'
import Meta from '../../components/meta/Meta'
import BackToTop from '../../components/components/backToTop/BackToTop'
import Search from '../../components/components/search/Search'
import { Section } from '../../components/core/section/Section'
import { Text } from '../../components/core/text/Text'
import s from '../../styles/pages/Memories.module.scss'
import { useEffect, useState } from 'react'

export default function Memories() {
    const [scrollY, setScrollY] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY >= 100 ? true : false)
        }
        handleScroll()
        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <Section>
            <Meta
                title="Minningarsíður - Hvern viltu finna?"
                seoTitle="Minningarsíður - Hvern viltu finna?"
                description="Sláðu inn nafn og/eða fæðingarár."
                type="website"
                url="https://minningar.is/memories"
                image="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/meta%2FMinningar_7V4A5309_01-min.jpg?alt=media&token=2e516f6e-b162-4b03-bb13-a10dcd5e1dc9"
            />
            <Container noGrid>
                <Text
                    variant="h1"
                    align="center"
                    style={{ marginBottom: '0.8em' }}
                >
                    Minningarsíður
                </Text>
            </Container>
            <Search />
            <Container className={s.backToTop}>
                <BackToTop column={12} row={1} span={1} isActive={scrollY} />
            </Container>
        </Section>
    )
}
